import { ENDPOINT } from 'api/endPoints/getListFilteredCards';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import {
    IHashmapItemWithCustomProps,
    IRowsBoard,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM } from 'components/Dashboards/Reporting/reportingConfig';

export const battlecardsRowsBoard: IHashmapItemWithCustomProps<IRowsBoard> = {
    NoPermissionMessage,
    id: 'battlecardsRowsBoard',
    componentKey: 'battlecardsRowsBoard',
    globalFiltersConfig: [],
    title: 'Activities Segment',
    reportStyle: {
        widgetSizesAvailable: { medium: MEDIUM, large: LARGE, extraLarge: EXTRA_LARGE },
        widgetInitialSize: LARGE,
    },
    endpoint: ENDPOINT,
};
